export default __webpack_public_path__ + "static/media/26_photo.6cd8d079.jpg";